import { useLocation, useNavigate } from "react-router";
import { DocumentList } from "../components/DocumentList";
import image from "../img/background-image-delete-document-treated.png";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import { useContext, useState } from "react";
import { MessageContext } from "../context/MessageContext";
import { CircularProgress } from "@mui/material";



function DeleteDocTreated() {
    const location = useLocation();
    const documents = location.state?.documents || {};
    const navigate = useNavigate();
    const { sendRequest } = useAxiosRequests();
    const { showSuccess, showError } = useContext(MessageContext);
    const [loading, setLoading] = useState(false);

    
    const handleProcess = async () => {
    setLoading(true);

        if(documents.isSubmit === true ){
            showError("Le fichier est en cours de réclamation.");
        }
        const formData = new FormData();
        formData.append("isSubmit", "true");
        try {
            const response = await sendRequest({ method: "POST", url: ExternalRoutes.document.isSubmit + documents?.id, body: formData });
            if (!response.status === 'error' || ![200, 201, 202, 204].includes(response.statusCode)) {
                showError(response.message || "Une erreur est survenue lors de la soumission.");
            }
            showSuccess("Votre réclamation a bien été prise en compte. Une équipe vous contactera prochainement.");
            navigate("/");
        } catch (error) {
            showError(error.message)
        }finally{
    setLoading(false);

        }
    }
    return (
        <>
            <section className="kl-delete-doc-treaded">
                <div className="kl-image-background-treated">
                    <img src={image} alt="delete document treated image " aria-hidden="true" />
                </div>
                <div className="kl-display-delete-document-treated">
                    <h2>Document verrouillé !</h2>
                    {documents ? (
                        <DocumentList document={documents} type={documents?.conDocumentStatus?.docStName} />
                    ) : (
                        <></>
                    )}
                    <div className="kl-text-delete-doc-treated">Votre expert a déjà traité ce document. Pour demander son retrait, soumettez une réclamation.</div>
                </div>
            </section>
            <section className="kl-delete-doc-content-tread">
                <div className="kl-button-delete-document">
                    <button className="btn kl-button-supprimer" onClick={handleProcess || loading}>
                    {
                        loading? 
                        <>
                            <CircularProgress size={15} color="inherit" />
                            <span className="mx-2">Soumission encours ...</span>
                        </>
                        :
                        "Soumettre une réclamation"
                    }
                        
                    </button>
                    <button onClick={() => window.history.back()} className="btn kl-button-back">
                        Revenir
                    </button>
                </div>
            </section>
        </>
    );
}

export default DeleteDocTreated;